module.exports = __webpack_public_path__ + "img/arbitrum.e1042aff.jpg";